// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2oXBD","actions":"GroupTable_actions__B_lub","deleteModalFooter":"GroupTable_deleteModalFooter__16J1Z"};